module.exports = __webpack_public_path__ + "assets/img/ef0f13da8b56f313ba3dc9b8c574a188.svg";